<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="toolBar">
      <form action="/">
        <van-search v-model="search.key" placeholder="姓名、时间、名称等" show-action @search="onSearch">
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
        <van-dropdown-menu>
          <van-dropdown-item v-model="search.diveShopId" :options="optionDiveShop" @change="onDiveShopChange" />
          <van-dropdown-item v-if="showoptionDiveShop" v-model="search.coachId" :options="optionCoach" @change="onSearch" />
          <van-dropdown-item v-model="search.diveCourseId" :options="optionCourse" @change="onSearch" />
          <van-dropdown-item v-model="search.state" :options="optionState" @change="onSearch" />
        </van-dropdown-menu>
      </form>
    </div>
    <div class="dataRect">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div v-for="item in list" :key="item.team.diveClassId" class="dataLine">
          <div @click="onClickClass(item.team.diveClassId)">
            <van-row>
              <van-col span="20" class="title">
                <van-tag plain :color="GetDiveMainBack()">{{ item.coachName }}</van-tag>
                {{ item.team.className }}
              </van-col>
              <van-col span="4" class="rigth"><van-tag :color="GetDiveMainBack()">{{ GetEnumText('Em_ClassState',item.team.state) }}</van-tag></van-col>
            </van-row>
            <van-row>
              <van-col span="14"><span class="key" :style="'color:'+GetDiveMainBack()">课程:</span> {{ item.courseName }}</van-col>
              <van-col span="10" class="rigth"><span class="key" :style="'color:'+GetDiveMainBack()">日期:</span> {{ formatDate(item.team.dateStart,'yyyy/MM/dd',true) }}</van-col>
            </van-row>
          </div>
          <div class="memberList">
            <div v-for="member in item.member" :key="member.studentId" class="memeberRect" @click="onClickMember(member.studentId)">
              <van-image
                width="4em"
                height="4em"
                fit="cover"
                radius="0.4em"
                lazy-load
                :src="member.icon?member.icon:'/img/defaultUserIcon.jpg'"
              />
              <div class="name">{{ member.name }}</div>
              <van-tag>{{ GetEnumText('Em_LearningState',member.state) }}</van-tag>
              <van-tag v-if="member.insurance && GetIsEnableInsurance()">{{ member.insurance }}</van-tag>
            </div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Search, DropdownMenu, DropdownItem, Tag, Image, Lazyload, List } from 'vant'
import TopBar from '@/components/TopBar'
import { getUrlKey, GetEnumList, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { checkInDropDownList, getDiveCenterList, getDiveCourseList } from '@/utils/baseData'
import { GetIsEnableInsurance, GetDiveMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Search.name]: Search,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Tag.name]: Tag,
    [Image.name]: Image,
    [Lazyload.name]: Lazyload,
    [List.name]: List,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '队伍列表',
      backurl: '/store/index',
      search: {
        key: undefined,
        diveCourseId: undefined,
        diveShopId: undefined,
        state: undefined,
        coachId: undefined,
        limit: 30,
        page: 1
      },
      loading: undefined,
      finished: false,
      list: [],
      optionCourseBase: [],
      optionCourse: [],
      optionState: [],
      optionDiveShop: [],
      optionCoach: [],
      showoptionDiveShop: false
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    getDiveCenterList((centerList) => {
      this.optionDiveShop = JSON.parse(JSON.stringify(centerList))
      this.optionDiveShop.unshift({ text: '不限中心', value: undefined, isEnable: true })
      getDiveCourseList((courseList) => {
        this.optionCourseBase = JSON.parse(JSON.stringify(courseList))
        this.optionCourse = JSON.parse(JSON.stringify(this.optionCourseBase))
        this.optionCourse.unshift({ text: '不限课程', value: undefined, isEnable: true })
      })
      this.optionState = GetEnumList('Em_ClassState')
      this.optionState.unshift({ text: '不限状态', value: undefined, isEnable: true })
    })
  },
  activated() {
    var diveCenterId = getUrlKey('diveCenterId')
    var coachId = getUrlKey('coachId')
    if (diveCenterId === null) {
      diveCenterId = undefined
    }
    if (coachId === null) {
      coachId = undefined
    }
    if (this.search.diveShopId !== diveCenterId || this.search.coachId !== coachId) {
      this.search.diveShopId = diveCenterId
      this.search.coachId = coachId
      if (this.search.diveShopId) {
        this.onDiveShopChange()
      }
    } else {
      this.init()
    }
  },
  methods: {
    GetIsEnableInsurance,
    getUrlKey,
    ShowMoney,
    GetColorMainLine,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onClickClass(id) {
      this.$router.push('/pro/trip/Class/' + id)
    },
    onClickMember(id) {
      this.$router.push('/pro/trip/trip/' + id)
    },
    onSearch() {
      console.log('onSearch', this.search)
      this.init()
    },
    init() {
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    onLoad() {
      console.log('onLoad')
      if (this.loading === undefined) {
        this.loading = true
        return
      }
      this.loading = true
      request({
        url: '/DiveTrip/getCoachDiveClassList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    },
    onDiveShopChange() {
      if (this.search.diveShopId) {
        this.optionCourse = JSON.parse(JSON.stringify(this.optionCourseBase.filter(m => m.diveShopId === this.search.diveShopId)))
        this.optionCourse.unshift({ text: '不限课程', value: undefined, isEnable: true })
        this.search.diveCourseId = checkInDropDownList(this.optionCourse, this.search.diveCourseId)
        this.initCoachList(this.search.diveShopId)
      } else {
        this.optionCourse = JSON.parse(JSON.stringify(this.optionCourseBase))
        this.optionCourse.unshift({ text: '不限课程', value: undefined, isEnable: true })
        this.showoptionDiveShop = false
        this.search.coachId = undefined
      }

      this.onSearch()
    },
    initCoachList(diveCenterId) {
      request({
        url: '/DiveTrip/GetAllCoachList',
        method: 'post',
        params: { id: diveCenterId }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.optionCoach = []
        if (response.data) {
          this.showoptionDiveShop = true
          this.optionCoach.push({ text: '只看自己', value: undefined, isEnable: true })
          this.optionCoach.push({ text: '不限教练', value: '0', isEnable: true })
          response.data.forEach(item => {
            this.optionCoach.push({ text: item.proName + '[' + item.realName + ']', value: item.userId })
          })
        } else {
          this.showoptionDiveShop = false
          this.search.coachId = undefined
        }
      })
    }
  }
}
</script>
<style scoped>
.dataRect{
    height: calc(100vh - 3em - 104px);
    overflow-y: scroll;
}
.dataRect .dataLine{
    background-color: #fff;
    padding:1em;
    border-bottom: 1px solid #f5f5f5;
    font-size: 0.8em;
}
.dataRect .dataLine:last-child{
    border-bottom: none;
}
.dataRect .dataLine .title{
    font-weight: 700;
}

.memberList{
    display: flex;
     flex-wrap: wrap;
     margin-top: 0.5em;
}
.memberList .memeberRect{
    max-width: calc(20vw - 1em);
    text-align: center;
    padding: 0.25em;
}
.memberList .name{
        overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  min-height: 4em;
}
.memberList span{
  margin-bottom:0.25em;
}
</style>
